import angular from 'angular';
import template from './template.html';
import { CandidatesListItem, CandidatesListItemConfiguration } from '../../../../../candidate/candidates-list/item';
import { RECRUITER_WORKFLOW_STATUS } from '../../../../constants/recruiter-workflow';
import './style.scss';
import { CANDIDATE_ACTIONS } from '../../../candidate-page/call-for-action-button';

export class RecruiterCandidatesListItem extends CandidatesListItem {
    $onChanges() {
        super.$onChanges(...arguments);

        const { candidate } = this;

        this.hiddenButtonVisible = this.isHiddenButtonVisible(candidate);
        this.currentActionButtonVisible = this.isCurrentActionButtonVisible(candidate);
    }

    isHiddenButtonVisible(candidate) {
        return this.isCallButtonVisible(candidate) && this.isCurrentWorkflowStatusHidden(candidate);
    }

    isCurrentActionButtonVisible(candidate) {
        return this.isCallButtonVisible(candidate) && !this.isCurrentWorkflowStatusHidden(candidate);
    }

    isCallButtonVisible(candidate) {
        return candidate.workflow
            && candidate.currentCallForAction
            && candidate.currentCallForAction !== CANDIDATE_ACTIONS.CLAIM
            && ![RECRUITER_WORKFLOW_STATUS.PROSPECT, RECRUITER_WORKFLOW_STATUS.SENT].some(s => s === candidate.workflow.recruiterStatus.current);
    }

    isCurrentWorkflowStatusHidden(candidate) {
        return candidate.workflow.recruiterStatus.current === RECRUITER_WORKFLOW_STATUS.HIDDEN;
    }
}

export const RecruiterCandidatesListItemConfiguration = {
    ...CandidatesListItemConfiguration,
    template,
    bindings: {
        ...CandidatesListItemConfiguration.bindings,
        showCandidateStatus: '<',
        currentRecruiter: '<',
        currentWorkflow: '<',
        isNewSearch: '<',
    },
    controller: RecruiterCandidatesListItem,
    controllerAs: 'recruiterCandidateListItemCtrl',
};

angular
    .module('TALENYA-FE')
    .component('recruiterCandidatesListItem', RecruiterCandidatesListItemConfiguration);
